import { IAccountComponentData } from "../../accounts/types/IAccountComponentData";
import { IAccountSocietyAffiliation } from "../../membersportal/types/IAccountSocietyAffiliation";
import { IUserCRMValues } from "../../membersportal/types/IUserCRMValues";
import { IInterestedParty } from "../../repertoire/types/IInterestedParty";
import { IMyPackagesDetails } from "../../repertoire/types/IMyPackagesDetails";
import { IUsageSearcResultConfiguration } from "../../repertoire/types/usageTypes/IUsageSearcResultConfiguration";

// Action names
type GET_USERS_REQUEST_TYPE = "GET_USERS_REQUEST";
type GET_USERS_SUCCESS_TYPE = "GET_USERS_SUCCESS";
type GET_USERS_FAILURE_TYPE = "GET_USERS_FAILURE";
type LOGIN_REQUEST_TYPE = "LOGIN_REQUEST";
type LOGIN_SUCCESS_TYPE = "LOGIN_SUCCESS";
type LOGIN_FAILURE_TYPE = "LOGIN_FAILURE";
type LOGOUT_REQUEST_TYPE = "LOGOUT_REQUEST";
type LOGOUT_SUCCESS_TYPE = "LOGOUT_SUCCESS";
type LOGOUT_FAILURE_TYPE = "LOGOUT_FAILURE";
type FETCH_ACCOUNT_COMPONENT_DATA_REQUEST_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_REQUEST";
type FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS";
type FETCH_ACCOUNT_COMPONENT_DATA_FAILURE_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_FAILURE";
type FETCH_APP_VERSION_NUMBER_REQUEST_TYPE = "FETCH_APP_VERSION_NUMBER_REQUEST";
type FETCH_APP_VERSION_NUMBER_SUCCESS_TYPE = "FETCH_APP_VERSION_NUMBER_SUCCESS";
type FETCH_APP_VERSION_NUMBER_FAILURE_TYPE = "FETCH_APP_VERSION_NUMBER_FAILURE";
type LOGIN_TYPE_REQUEST_TYPE = "LOGIN_TYPE_REQUEST";
type LOGIN_TYPE_SUCCESS_TYPE = "LOGIN_TYPE_SUCCESS";
type LOGIN_TYPE_FAILURE_TYPE = "LOGIN_TYPE_FAILURE";
type SAVE_ROLES_TYPE = "SAVE_ROLES";
type SET_PORTAL_TYPE_TYPE = "SET_PORTAL_TYPE";
type SET_CLIENT = "SET_CLIENT";
type GET_CUSTOMER_SUCCESS_TYPE = "GET_CUSTOMER_SUCCESS";
type GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS"
type GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS"
type GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS_TYPE = "GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS"
type GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS";
type GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS";
type GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS_TYPE = "GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS"; 
type GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS";
type GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS_TYPE = "GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS"
type GET_USER_NAMENUMBER_SUCCESS_TYPE = "GET_USER_NAMENUMBER_SUCCESS";
type GET_USER_CRM_VALUES_SUCCESS_TYPE = "GET_USER_CRM_VALUES_SUCCESS";
type SET_CURRENT_USER_NAME_NUMBER_TYPE = "SET_CURRENT_USER_NAME_NUMBER";
type GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS_TYPE = "GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS";
type GET_MEMBER_NUMBER_SUCCESS_TYPE = "GET_MEMBER_NUMBER_SUCCESS";
type GET_ROLL_UP_TERRITORIES_SUCCESS_TYPE = "GET_ROLL_UP_TERRITORIES_SUCCESS";
type GET_ALL_PACKAGES_DETAILS_SUCCESS_TYPE = "GET_ALL_PACKAGES_DETAILS_SUCCESS";
type GET_ALL_PACKAGES_DETAILS_FAILURE_TYPE = "GET_ALL_PACKAGES_DETAILS_FAILURE";
type GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST";
type GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS";
type GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE";
type GET_IP_DETAILS_SUCCESS_TYPE = "GET_IP_DETAILS_SUCCESS";
type GET_IP_DETAILS_FAILURE_TYPE = "GET_IP_DETAILS_FAILURE";
type SET_MEMBERS_PORTAL_USER_ROLES_TYPE = "SET_MEMBERS_PORTAL_USER_ROLES";
type CLEAR_ACCOUNT_CONTEXT_TYPE = "CLEAR_ACCOUNT_CONTEXT";
type SET_ACCOUNT_SOCIETY_AFFILIATION_TYPE = "SET_ACCOUNT_SOCIETY_AFFILIATION";

// Action types
export interface GetUsersRequest {
    type: GET_USERS_REQUEST_TYPE;
}

export interface GetUsersSuccess {
    type: GET_USERS_SUCCESS_TYPE;
    payload: {
        users: string[];
    };
}

export interface GetUsersFailure {
    type: GET_USERS_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface LoginRequest {
    type: LOGIN_REQUEST_TYPE;
}

export interface LoginSuccess {
    type: LOGIN_SUCCESS_TYPE;
    payload: {
        username: string;
        currentUserNameNumber: string
    };
}

export interface LoginFailure {
    type: LOGIN_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface LogoutRequest {
    type: LOGOUT_REQUEST_TYPE;
}

export interface LogoutSuccess {
    type: LOGOUT_SUCCESS_TYPE;
}

export interface LogoutFailure {
    type: LOGOUT_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface AccountComponentDataRequest {
    type: FETCH_ACCOUNT_COMPONENT_DATA_REQUEST_TYPE;
}

export interface AccountComponentDataSuccess {
    type: FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS_TYPE;
    payload: {
        componentData: IAccountComponentData;
    };
}

export interface AccountComponentDataFailure {
    type: FETCH_ACCOUNT_COMPONENT_DATA_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface AppVersionNumberRequest {
    type: FETCH_APP_VERSION_NUMBER_REQUEST_TYPE;
}

export interface AppVersionNumberSuccess {
    type: FETCH_APP_VERSION_NUMBER_SUCCESS_TYPE;
    payload: {
        appVersionNumber: string;
    };
}

export interface AppVersionNumberFailure {
    type: FETCH_APP_VERSION_NUMBER_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface LoginTypeRequest {
    type: LOGIN_TYPE_REQUEST_TYPE;
}

export interface LoginTypeSuccess {
    type: LOGIN_TYPE_SUCCESS_TYPE;
    payload: {
        loginType: string;
    };
}

export interface LoginTypeFailure {
    type: LOGIN_TYPE_FAILURE_TYPE;
    payload: {
        error: string;
    };
}

export interface SaveRoles {
    type: SAVE_ROLES_TYPE;
    payload: {
        roles: string[];
    };
}

export interface SetPortalType {
    type: SET_PORTAL_TYPE_TYPE;
    payload: {
        portalType: string;
    }
}

export interface SetClient {
    type: SET_CLIENT;
    payload: {
        client: string;
    }
}

export interface GetCustomerSuccess {
    type: GET_CUSTOMER_SUCCESS_TYPE;
    payload: {
        customer: string;
    }
}

export interface GetCustomerContributorTypesConfigurationSuccess {
    type: GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        contributorTypes: string[];
    }
}

export interface GetCustomerNamesTypesConfigurationSuccess {
    type: GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        customerNameTypes: string[];
    }
}

export interface GetCustomerDefaultTerritoriesSuccess {
    type: GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS_TYPE;
    payload: {
        defaultTerritories: any;
    }
}


export interface GetCatchUpAllocationsConfigurationSuccess {
    type: GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        enableCatchupAllocations: boolean;
    }
}

export interface GetCustomerDateConfigurationSuccess {
    type: GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        customerDate: string;
    }
}

export interface GetCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess {
    type: GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        isUsageTabDefaultSetToMatch: boolean;
    }
}

export interface GetMemberNumberConfigurationSuccess {
    type: GET_MEMBER_NUMBER_SUCCESS_TYPE;
    payload: {
        enableMemberNumber: boolean;
    }
}
export interface GetRollUpTerritoriesConfigurationSuccess {
    type: GET_ROLL_UP_TERRITORIES_SUCCESS_TYPE;
    payload: {
        enableRollUpTerritories: boolean;
    }
}

export interface GetAllPackagesDetailsSuccess {
    type: GET_ALL_PACKAGES_DETAILS_SUCCESS_TYPE;
    payload: {
        myPackagesDetails: IMyPackagesDetails[];
    };
}

export interface GetAllPackagesDetailsFailure {
    type: GET_ALL_PACKAGES_DETAILS_FAILURE_TYPE;
    payload: {
        error: string;
        userName: string;
    };
}
export interface GetIPDetailsSuccess {
    type: GET_IP_DETAILS_SUCCESS_TYPE;
    payload: {
        ipDetails: IInterestedParty;
    }
}

export interface GetIPDetailsFailure {
    type: GET_IP_DETAILS_FAILURE_TYPE;
    payload: {
        error: string;
        ipBaseNumber?: string;
        accountNumber?: string;
    }
}

export interface GetEnabledAdjustmentICEWorkSearchRequest {
    type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST_TYPE;
}

export interface GetEnabledAdjustmentICEWorkSearchSuccess {
    type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS_TYPE;
    payload: {
        enableAdjustmentICEWorkSearch: boolean;
    }
}

export interface GetEnabledAdjustmentICEWorkSearchFailure {
    type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE_TYPE;
    payload: {
        error: any
    }
}

export interface GetCustonerTimeZoneConfigurationSuccess {
    type: GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        customerTimeZone: string;
    }
}
export interface GetAllocationCustomerTerritoryConfigurationSuccess {
    type: GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS_TYPE;
    payload: {
        allocationCustomerTerritory: string;
    }
}


export interface GetUserCRMValuesSuccess {
    type: GET_USER_CRM_VALUES_SUCCESS_TYPE;
    payload: {
        userCRMValues: IUserCRMValues;
    }
}

export interface SetCurrentUserNameNumber {
    type: SET_CURRENT_USER_NAME_NUMBER_TYPE;
    payload: {
        userCRMValues: IUserCRMValues;
    }
}

export interface GetUsageSearchResultConfigurationSuccess {
    type: GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS_TYPE;
    payload: {
        customerUsageSearchResult: IUsageSearcResultConfiguration;
    }
}

export interface ClearAccountContext {
    type: CLEAR_ACCOUNT_CONTEXT_TYPE;
}

export interface SetAccountSocietyAffiliation {
    type: SET_ACCOUNT_SOCIETY_AFFILIATION_TYPE;
    payload: {
        accountSocietyAffiliation: IAccountSocietyAffiliation;
    };
}

export type ActionTypes =
    GetUsersRequest
    | GetCatchUpAllocationsConfigurationSuccess
    | GetUsersFailure
    | GetUsersSuccess
    | LoginRequest
    | LoginFailure
    | LoginSuccess
    | LogoutRequest
    | LogoutFailure
    | LogoutSuccess
    | AccountComponentDataRequest
    | AccountComponentDataFailure
    | AccountComponentDataSuccess
    | AppVersionNumberRequest
    | AppVersionNumberFailure
    | AppVersionNumberSuccess
    | LoginTypeRequest
    | LoginTypeFailure
    | LoginTypeSuccess
    | SaveRoles
    | SetPortalType
    | SetClient
    | GetUserCRMValuesSuccess
    | GetCustomerSuccess
    | GetCustomerDefaultTerritoriesSuccess
    | GetCustomerNamesTypesConfigurationSuccess
    | GetCustomerDateConfigurationSuccess
    | GetCustomerContributorTypesConfigurationSuccess
    | GetCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess
    | GetCustonerTimeZoneConfigurationSuccess
    | SetCurrentUserNameNumber
    | GetUsageSearchResultConfigurationSuccess
    | GetMemberNumberConfigurationSuccess
    | GetRollUpTerritoriesConfigurationSuccess
    | GetAllPackagesDetailsSuccess
    | GetAllPackagesDetailsFailure
    | GetEnabledAdjustmentICEWorkSearchRequest
    | GetEnabledAdjustmentICEWorkSearchSuccess
    | GetEnabledAdjustmentICEWorkSearchFailure
    | GetIPDetailsSuccess
    | GetIPDetailsFailure
    | GetAllocationCustomerTerritoryConfigurationSuccess
    | ClearAccountContext
    | SetAccountSocietyAffiliation;

export const GET_USERS_REQUEST: GET_USERS_REQUEST_TYPE = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS: GET_USERS_SUCCESS_TYPE = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE: GET_USERS_FAILURE_TYPE = "GET_USERS_FAILURE";
export const LOGIN_REQUEST: LOGIN_REQUEST_TYPE = "LOGIN_REQUEST";
export const LOGIN_SUCCESS: LOGIN_SUCCESS_TYPE = "LOGIN_SUCCESS";
export const LOGIN_FAILURE: LOGIN_FAILURE_TYPE = "LOGIN_FAILURE";
export const LOGOUT_REQUEST: LOGOUT_REQUEST_TYPE = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS: LOGOUT_SUCCESS_TYPE = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE: LOGOUT_FAILURE_TYPE = "LOGOUT_FAILURE";
export const FETCH_ACCOUNT_COMPONENT_DATA_REQUEST: FETCH_ACCOUNT_COMPONENT_DATA_REQUEST_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_REQUEST";
export const FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS: FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS";
export const FETCH_ACCOUNT_COMPONENT_DATA_FAILURE: FETCH_ACCOUNT_COMPONENT_DATA_FAILURE_TYPE = "FETCH_ACCOUNT_COMPONENT_DATA_FAILURE";
export const FETCH_APP_VERSION_NUMBER_REQUEST: FETCH_APP_VERSION_NUMBER_REQUEST_TYPE = "FETCH_APP_VERSION_NUMBER_REQUEST";
export const FETCH_APP_VERSION_NUMBER_SUCCESS: FETCH_APP_VERSION_NUMBER_SUCCESS_TYPE = "FETCH_APP_VERSION_NUMBER_SUCCESS";
export const FETCH_APP_VERSION_NUMBER_FAILURE: FETCH_APP_VERSION_NUMBER_FAILURE_TYPE = "FETCH_APP_VERSION_NUMBER_FAILURE";
export const LOGIN_TYPE_REQUEST: LOGIN_TYPE_REQUEST_TYPE = "LOGIN_TYPE_REQUEST";
export const LOGIN_TYPE_SUCCESS: LOGIN_TYPE_SUCCESS_TYPE = "LOGIN_TYPE_SUCCESS";
export const LOGIN_TYPE_FAILURE: LOGIN_TYPE_FAILURE_TYPE = "LOGIN_TYPE_FAILURE";
export const SAVE_ROLES: SAVE_ROLES_TYPE = "SAVE_ROLES";
export const SET_PORTAL_TYPE: SET_PORTAL_TYPE_TYPE = "SET_PORTAL_TYPE"
export const SET_CLIENT: SET_CLIENT = "SET_CLIENT"
export const GET_CUSTOMER_SUCCESS: GET_CUSTOMER_SUCCESS_TYPE = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS: GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS"
export const GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS: GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS"
export const GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS: GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS_TYPE = "GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS"
export const GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS: GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS";
export const GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS: GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS";
export const GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS: GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS_TYPE = "GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS";
export const GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS: GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS_TYPE = "GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS";
export const GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS: GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS_TYPE ="GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS"
export const GET_USER_NAMENUMBER_SUCCESS: GET_USER_NAMENUMBER_SUCCESS_TYPE = "GET_USER_NAMENUMBER_SUCCESS";
export const GET_MEMBER_NUMBER_SUCCESS: GET_MEMBER_NUMBER_SUCCESS_TYPE = "GET_MEMBER_NUMBER_SUCCESS";
export const GET_ROLL_UP_TERRITORIES_SUCCESS: GET_ROLL_UP_TERRITORIES_SUCCESS_TYPE = "GET_ROLL_UP_TERRITORIES_SUCCESS";
export const GET_ALL_PACKAGES_DETAILS_SUCCESS: GET_ALL_PACKAGES_DETAILS_SUCCESS_TYPE = "GET_ALL_PACKAGES_DETAILS_SUCCESS";
export const GET_ALL_PACKAGES_DETAILS_FAILURE: GET_ALL_PACKAGES_DETAILS_FAILURE_TYPE = "GET_ALL_PACKAGES_DETAILS_FAILURE";
export const GET_USER_CRM_VALUES_SUCCESS: GET_USER_CRM_VALUES_SUCCESS_TYPE = "GET_USER_CRM_VALUES_SUCCESS";
export const SET_CURRENT_USER_NAME_NUMBER: SET_CURRENT_USER_NAME_NUMBER_TYPE = "SET_CURRENT_USER_NAME_NUMBER";
export const GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS: GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS_TYPE = "GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS";
export const GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST";
export const GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS";
export const GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE_TYPE = "GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE";
export const GET_IP_DETAILS_SUCCESS: GET_IP_DETAILS_SUCCESS_TYPE = "GET_IP_DETAILS_SUCCESS";
export const GET_IP_DETAILS_FAILURE: GET_IP_DETAILS_FAILURE_TYPE = "GET_IP_DETAILS_FAILURE";
export const SET_MEMBERS_PORTAL_USER_ROLES: SET_MEMBERS_PORTAL_USER_ROLES_TYPE = "SET_MEMBERS_PORTAL_USER_ROLES";
export const CLEAR_ACCOUNT_CONTEXT: CLEAR_ACCOUNT_CONTEXT_TYPE = "CLEAR_ACCOUNT_CONTEXT";
export const SET_ACCOUNT_SOCIETY_AFFILIATION: SET_ACCOUNT_SOCIETY_AFFILIATION_TYPE = "SET_ACCOUNT_SOCIETY_AFFILIATION";
